import {useAuth} from '../../../../app/modules/auth'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu, Search} from '../../../partials'

/* eslint-disable jsx-a11y/anchor-is-valid */
const API_URL:any = process.env.REACT_APP_KT_API_URL
const BASE_URL = API_URL.replace(/\/api$/, '')
const AsideToolbar = () => {
  const {currentUser} = useAuth()

  return (
    <>
      {/* Metronic adds `.show` to the menu trigger while the user menu is open */}
      <style>{`
        .aside-user-arrow { transition: transform 0.2s ease; }
        .show > .aside-user-arrow { transform: rotate(180deg); }
      `}</style>
      {/*begin::User*/}
      <div
        className='aside-user'
        style={{padding: '14px 13px 10px', borderTop: '1px solid #2d2d43'}}
      >
        {/*begin::Account card (click opens the user menu)*/}
        <div
          className='d-flex align-items-center'
          style={{
            background: 'rgba(255, 255, 255, 0.06)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '0.475rem',
            padding: '10px 12px',
            cursor: 'pointer',
            position: 'relative',
          }}
          data-kt-menu-trigger='click'
          data-kt-menu-placement='bottom-start'
          data-kt-menu-attach='#aside-user-menu-anchor'
          data-kt-menu-overflow='false'
        >
          {/* Invisible anchor: the user menu aligns to this point (right of the avatar, 8px below the card) */}
          <span
            id='aside-user-menu-anchor'
            style={{position: 'absolute', left: 166, bottom: -8, width: 0, height: 0, pointerEvents: 'none'}}
          ></span>
          {/*begin::Symbol*/}
          <div className='position-relative flex-shrink-0' style={{height: 40, width: 40}}>
            <img
              style={{objectFit: 'cover', height: '100%', width: '100%', borderRadius: '50%'}}
              src={
                currentUser?.profile_picture
                  ? `${BASE_URL}/uploads/profile-pictures/${currentUser?.profile_picture}`
                  : toAbsoluteUrl('/media/avatars/300-1.jpg')
              }
              alt='Profile Picture'
              className='avatar-img'
            />
            {/* online status */}
            <span
              className='position-absolute bg-success'
              title='online'
              style={{
                width: 10,
                height: 10,
                right: 0,
                bottom: 0,
                borderRadius: '50%',
                boxShadow: '0 0 0 2px rgba(0, 0, 0, 0.35)',
              }}
            ></span>
          </div>
          {/*end::Symbol*/}

          {/*begin::Info*/}
          <div className='flex-grow-1 ms-3 overflow-hidden'>
            <div
              className='text-white fs-6 fw-bold text-truncate'
              style={{textTransform: 'capitalize'}}
            >
              {[currentUser?.first_name, currentUser?.last_name].filter(Boolean).join(' ') || 'User'}
            </div>
            <div className='text-gray-600 fw-semibold fs-8 text-truncate'>
              {currentUser?.roles?.map((r) => r.name).join(', ')}
            </div>
          </div>
          {/*end::Info*/}

          <svg
            width='16'
            height='16'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#99a1b7'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='aside-user-arrow ms-2 flex-shrink-0'
          >
            <path d='m6 9 6 6 6-6' />
          </svg>
        </div>
        {/*end::Account card*/}

        <HeaderUserMenu variant='sidebar' />
      </div>
      {/*end::User*/}

      {/*begin::Aside search*/}
    {/*  <div className='aside-search py-5'>*/}
    {/*    /!* <?php Theme::getView('partials/search/_inline', array(*/}
    {/*    'class' => 'w-100',*/}
    {/*    'menu-placement' => 'bottom-start',*/}
    {/*    'responsive' => 'false'*/}
    {/*))?> *!/*/}
    {/*    <Search />*/}
    {/*  </div>*/}
      {/*end::Aside search*/}
    </>
  )
}

export {AsideToolbar}
